
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import 'react';
import Heading from '../../Heading/Heading.js';
import Button from '../../Button/Button.js';
import SvgClose from '../../../icons/legacy/close.svg.js';
import { drawerHeader } from './styles.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var Header = function Header(_ref) {
  var onClose = _ref.onClose,
    _ref$noGutters = _ref.noGutters,
    noGutters = _ref$noGutters === void 0 ? false : _ref$noGutters,
    children = _ref.children;
  var title = typeof children === "string" ? jsx(Heading, null, children) : children;
  var showCloseButton = Boolean(onClose);
  return jsx("header", {
    id: "drawer-title",
    "data-testid": "drawer-header",
    css: function css() {
      return drawerHeader({
        noGutters: noGutters
      });
    }
  }, title, showCloseButton && jsx(Button, {
    type: "button",
    variant: "link",
    color: "secondary",
    noGutters: true,
    "aria-label": "Close drawer",
    onClick: onClose
  }, jsx(SvgClose, {
    height: 24
  })));
};

export { Header as default };
//# sourceMappingURL=Header.js.map
